import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { trackDatadogRumError } from 'utils/initDatadogRum';
import { IDealsQueryParams, IDealsResponse } from '../types';
import { buildDealFiltersQueryString } from '../helpers/dealFilters';

const getDeals = async ({
    pageSize, currentPage, orgId, searchValue, sortBy, sortOrder, groupId, subprojectStageIds, selectedUnitType, filters,
}: IDealsQueryParams): Promise<IDealsResponse> => {
    const includeSearch = searchValue ? `&search=${searchValue}` : '';
    const sortByValue = sortBy ? sortBy.split('.')[0] : '';
    const includeSort = sortByValue && sortOrder ? `&${sortByValue}=${sortOrder}` : '';
    const includeGroupId = groupId ? `&deal_group_id=${groupId}` : '';
    const includeSubprojectStageIds = subprojectStageIds ? `&${subprojectStageIds}` : '';
    const includeUnitType = selectedUnitType ? `&unit_type=${selectedUnitType}` : '';
    const includeFilters = buildDealFiltersQueryString(filters);
    const { data } = await axiosInstance.get(
        // eslint-disable-next-line max-len
        `${API_ENDPOINTS.DEALS(orgId)}?page=${currentPage - 1}&page_size=${pageSize}${includeSearch}${includeSort}${includeGroupId}${includeSubprojectStageIds}${includeUnitType}${includeFilters}`,
    );
    if (!Array.isArray(data?.items)) {
        trackDatadogRumError(
            new Error('[useGetDeals] Expected items array response'),
            { receivedType: typeof data?.items, receivedValue: data },
        );
    }
    return {
        ...data,
        items: Array.isArray(data?.items) ? data.items : [],
    };
};

export const useGetDeals = (
    {
        pageSize, currentPage, orgId, searchValue, sortBy, sortOrder, groupId, subprojectStageIds, selectedUnitType, filters,
    }: IDealsQueryParams,
    options?: { enabled?: boolean },
) => useQuery({
    queryKey: [
        QUERY_KEYS.DEALS, orgId, currentPage, pageSize, searchValue, sortBy, sortOrder,
        groupId, subprojectStageIds, selectedUnitType, buildDealFiltersQueryString(filters),
    ],
    queryFn: () => getDeals({
        pageSize, currentPage, orgId, searchValue, sortBy, sortOrder, groupId, subprojectStageIds, selectedUnitType, filters,
    }),
    staleTime: 5000,
    refetchOnWindowFocus: true,
    enabled: options?.enabled ?? true,
});
